import React from 'react';

import { closeCurrentPopup } from '@paragon/popup-state';

import { deleteRoofContainerAndAssociatedTrussEnvelopes } from '../../store/actions/deletionActions';
import { RoofContainerConfirmationProps } from '../../store/actions/popupActions';
import { useAppDispatch } from '../hooks';
import { ConfirmDialog } from './ConfirmDialog';

export function DeleteRoofContainerConfirmDialog({ projectGuid, roofContainer }: RoofContainerConfirmationProps) {
  const dispatch = useAppDispatch();

  return (
    <ConfirmDialog
      open
      title="Confirm Delete"
      message={`Are you sure you want to delete roof container "${roofContainer.name}" and all of its truss envelopes?`}
      onClose={async (confirmed) => {
        dispatch(closeCurrentPopup());
        if (confirmed) {
          await dispatch(deleteRoofContainerAndAssociatedTrussEnvelopes(projectGuid, roofContainer));
        }
      }}
    />
  );
}
